import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Switch } from "@progress/kendo-react-inputs";
import { Upload } from "@progress/kendo-react-upload";
import {
    DeleteFile,
    UploadFiletoDirectory,
} from "../../Helpers/DateLakeStorage";
import Loader from "../../Shared/Loader/loader";
import { GlobalContext } from "../../../Renderers/GlobalContext";
import { ENTITY_LABEL } from "../../Helpers/Labels/EntityLabel";
import { getPortal, getPortalEntityTargetPage, updatePortal } from "../../../API/Portal/Portal";
import { getPortalAndLandingPage } from "../../Helpers/DisplayTemplates/DisplayPages";
import { withTranslation } from "react-i18next";
import { getEntities } from "../../../API/Entity/Entity";
import { getPage } from "../../../API/Display/Display";

class NavigationBarandLogo extends Component {

    static contextType = GlobalContext

    NavigationBarOrientation = [
        { text: "Top", value: "Top" },
        { text: "Left", value: "Left" }
    ];

    defaultData = {};

    saveButton = React.createRef();

    constructor(props) {
        super(props);
        this.state = {
            entities: [{ name: this.props.t("dropdown_values.select_object"), _id: "" }],
            pages: [{ pageName: this.props.t("dropdown_values.select_page"), _id: "" }],
            entity: { name: this.props.t("dropdown_values.select_object"), _id: "" },
            page: { name: this.props.t("dropdown_values.select_page"), _id: "" },
            portal: {},
            disabled: true,
            favicon: [],
            logo: [],
            loading: true
        };
    }

    componentDidMount = async () => {
        let entities = await this.getAllEntities();
        let portal = await this.getPortalDetails();
        let entity = this.state.entity
        let pages = this.state.pages
        let page = this.state.page
        if (portal.targetPageId && portal.targetPageId !== "") {
            page = await getPage(portal.targetPageId);
            if (page) {
                entity = entities.find(entity => entity._id === page.entityId);
                pages = await this.getPages(page.entityId);
            } else {
                page = this.state.page;
                entity = this.state.entity;
            }
        }
        this.defaultData = {
            ...portal,
            entity: entity,
            page: page,
        };
        this.setState({
            portal: portal,
            entities,
            pages: pages,
            entity: entity,
            page: page,
            loading: false
        })
    };

    render() {
        const { subscription } = this.context.state
        const { t } = this.props;
        if (this.state.loading) {
            return <Loader />;
        }
        return (
            <div className="container-fluid">
                <div
                    style={{ padding: "20px 0px" }}
                    className="row overflow-auto"
                >
                    <div className="col-lg-12">
                        <div>
                            <form onSubmit={this.Save}>
                                <div className="mb-3 float-end">
                                    <button
                                        ref={this.saveButton}
                                        title="Save"
                                        type="submit"
                                        disabled={this.state.disabled}
                                        className="btn btn-primary me-2"
                                    >
                                        <i className="fas fa-save me-1"></i>
                                        {t("buttons.save_button_label")}
                                    </button>
                                    <button
                                        className="btn btn-secondary"
                                        type="button"
                                        title="Refresh"
                                        disabled={this.state.disabled}
                                        onClick={this.reset}
                                    >
                                        <span className="k-icon k-i-undo pb-1 me-1"></span>
                                        {t("buttons.revert_changes_button_label")}
                                    </button>
                                </div>
                                <div className="ms-2">
                                    <div className="form-label">
                                        {t("navigation_bar_orientation.label")}
                                    </div>
                                    <DropDownList
                                        data={this.getNavigationOrientationData()}
                                        className="customDropDown"
                                        style={{ width: "15rem" }}
                                        value={this.getNavigationOrientationValue(this.state.portal.navigationBarOrientation)}
                                        onChange={this.handleNavBar}
                                        textField="text"
                                    />
                                </div>
                                <div className="overview-divider"></div>

                                <div className="ms-2">
                                    <div className="form-label d-inline-block me-2 mb-2">
                                        {t("default_landing_page.title")}
                                    </div>
                                    {/* {this.state.page && this.state.page._id ? (
                                        <Link to={`/${this.props.organization.orgName}/${this.props.project.name}/Entities/${this.state.entity.sysName}/Display/${this.state.page.pageName}`}>
                                            <i className="fal fa-external-link"></i>
                                        </Link>
                                    ) : null} */}
                                    <div className="py-2">
                                        <div className="form-label">
                                            {t("default_landing_page.object_field_label")}
                                        </div>
                                        <DropDownList
                                            data={this.state.entities}
                                            style={{ width: "15rem" }}
                                            textField="name"
                                            value={this.state.entity}
                                            onChange={this.handleEntity}
                                        />
                                    </div>
                                    <div className="py-2">
                                        <div className="form-label">
                                            {t("default_landing_page.page_field_label")}
                                        </div>
                                        <DropDownList
                                            data={this.state.pages}
                                            style={{ width: "15rem" }}
                                            value={this.state.page}
                                            textField={"pageName"}
                                            onChange={this.handlePage}
                                            disabled={this.state.entity._id === ""}
                                        />
                                    </div>
                                    <div className="py-2">
                                        <div className="form-label">
                                            {t("default_landing_page.navigate_to_default_page_field_label")}
                                        </div>
                                        <Switch
                                            disabled={this.state.entity._id}
                                            checked={this.state.portal.navigateToDefaultPage}
                                            onChange={this.handleNavToDefaultPage}
                                        />
                                    </div>
                                </div>
                                {true ?
                                    <Fragment>
                                        <div className="overview-divider"></div>
                                        <div className="ms-2">
                                            <div className="form-label d-inline-block me-2 mb-2">
                                                {t("logos.title")}
                                            </div>
                                            <div className="d-flex">
                                                <div
                                                    className="me-4"
                                                    style={{ width: "30%" }}
                                                >
                                                    <div className="form-label">
                                                        {t("logos.portal_logo_field_label")}
                                                    </div>
                                                    <div className="pb-2 text-muted">
                                                        {t("logos.portal_logo_field_description")}
                                                    </div>
                                                    <Upload
                                                        showActionButtons={false}
                                                        autoUpload={false}
                                                        multiple={false}
                                                        onAdd={this.handleLogo}
                                                        onRemove={this.handleLogoRemove}
                                                        files={this.state.logo}
                                                        restrictions={{
                                                            allowedExtensions: [".jpg", ".png", ".jpeg"],
                                                            maxFileSize: 4000000,
                                                        }}
                                                    />
                                                    {this.state.portal.logoUrl === "" ?
                                                        null :
                                                        (
                                                            <>
                                                                <img
                                                                    alt="logo"
                                                                    className="plogo"
                                                                    height={"80px"}
                                                                    src={`${process.env.REACT_APP_DATALAKESTORAGE_URL}/${process.env.REACT_APP_DATALAKESTORAGE_CONTAINER}/${this.props.organization._id}/${this.props.project._id}/PortalImages/${this.state.portal.logoUrl}`}
                                                                />
                                                                <i
                                                                    onClick={this.handleLogoReset}
                                                                    className="fas fa-times text-danger ms-3"
                                                                ></i>
                                                            </>
                                                        )
                                                    }
                                                </div>
                                                <div style={{ width: "30%" }}>
                                                    <div className="form-label">
                                                        {t("logos.favicon_field_label")}
                                                    </div>
                                                    <div className="pb-2 text-muted">
                                                        {t("logos.favicon_field_description")}
                                                    </div>
                                                    <Upload
                                                        showActionButtons={false}
                                                        autoUpload={false}
                                                        multiple={false}
                                                        onAdd={this.handleFavicon}
                                                        files={this.state.favicon}
                                                        onRemove={this.handleFaviconRemove}
                                                        restrictions={{
                                                            allowedExtensions: [".ico"],
                                                            maxFileSize: 4000000,
                                                        }}
                                                    />
                                                    <br></br>
                                                    {this.state.portal.faviconUrl === "" ?
                                                        null :
                                                        (
                                                            <>
                                                                <img
                                                                    alt="favicon"
                                                                    className="favicon"
                                                                    height={"40px"}
                                                                    src={`${process.env.REACT_APP_DATALAKESTORAGE_URL}/${process.env.REACT_APP_DATALAKESTORAGE_CONTAINER}/${this.props.organization._id}/${this.props.project._id}/PortalImages/${this.state.portal.faviconUrl}`}
                                                                />
                                                                <i
                                                                    onClick={this.handleFaviconReset}
                                                                    className="fas fa-times text-danger ms-3"
                                                                ></i>
                                                            </>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </Fragment>
                                    :
                                    <Fragment>
                                        <div className="overview-divider"></div>
                                        <a rel="noreferrer" className="alert alert-warning" href={`/_Payment/${this.props.organization._id}`} target="_blank">
                                            <i class="far fa-bolt me-2"></i>
                                            {t("upgrade_subscription_message")}
                                        </a>
                                    </Fragment>
                                }
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    getPortalDetails = async () => {
        let portal = await getPortal(this.props.portal._id);
        portal.navigationBarOrientation = this.NavigationBarOrientation.find(item => item.value === portal.navigationBarOrientation) || this.NavigationBarOrientation[0];
        portal.logoUrl = portal.logoUrl || "";
        portal.faviconUrl = portal.faviconUrl || "";
        portal.entityId = portal.entityId || "";
        portal.navigateToDefaultPage = portal.navigateToDefaultPage === "true" || portal.navigateToDefaultPage === true ? true : false;
        portal.targetPageId = portal.targetPageId || "";
        return portal;
    };

    getNavigationOrientationData = () => {
        const { t } = this.props;
        const data = this.NavigationBarOrientation.map((item) => {
            const text = t("navigation_bar_orientation.dropdown_values." + item.value.toLowerCase());
            const value = item.value;
            return {
                text,
                value
            };
        });
        return data;
    };

    getNavigationOrientationValue = (dataItem) => {
        debugger
        const { t } = this.props;
        debugger
        const text = t("navigation_bar_orientation.dropdown_values." + dataItem.value.toLowerCase());
        return {
            text,
            value: dataItem.value
        }
    };

    getAllEntities = async () => {
        const { portal, t } = this.props;
        let entities = await getEntities(this.props.project._id);
        const portalEntities = entities.filter(entity =>
            entity.configurations &&
            entity.configurations[portal._id] &&
            entity.configurations[portal._id].useInPortal === true
        )
        return [{ name: t("dropdown_values.select_object"), _id: "" }, ...portalEntities];
    };

    getPages = async (entityId) => {
        const { data: pagesData } = await getPortalEntityTargetPage(
            this.props.portal._id,
            entityId
        );

        const pages = pagesData.filter(
            (page) =>
                page.pageType === "Entity Group" &&
                page.subPageType !== "List" &&
                page.subPageType !== "Link Record" &&
                page.subPageType !== "Search" &&
                !page.useAsReference
        );

        const startPage = [
            {
                pageName: this.props.t("dropdown_values.select_page"),
                _id: ""
            }
        ]

        return pages.length > 0
            ? [
                ...startPage,
                ...pages
            ]
            : startPage;;
    };

    handleEntity = async (e, setDisabled = true) => {
        let entity = { ...e.target.value };
        let pages = this.state.pages;

        if (entity._id !== "") {
            pages = await this.getPages(entity._id);
        }

        this.setState({
            entity: entity,
            pages: pages,
            page: this.state.pages[0],
        }, () => {
            if (setDisabled) {
                this.setDisabled();
            }
        });
    };

    reset = () => {
        const data = { ...this.defaultData };
        this.setState({
            portal: data,
            entity: data.entity,
            page: data.page,
            logo: [],
            favicon: [],
        }, () => {
            this.setDisabled();
        });
    };

    handleNavBar = (e) => {
        const portal = this.state.portal;
        portal.navigationBarOrientation = e.target.value;
        this.setState({
            portal: portal,
        }, () => {

            this.setDisabled();
        });
    };

    handleNavToDefaultPage = (e) => {
        const portal = this.state.portal;
        portal.navigateToDefaultPage = e.target.value;
        this.setState({
            portal: portal
        }, () => {
            this.setDisabled();
        })
    }

    handlePage = (e) => {
        this.setState({
            page: e.target.value,
        }, () => {
            this.setDisabled();
        })
    }

    handleLogo = (event) => {
        this.setState({
            logo: event.newState,
        }, () => {
            this.setDisabled();
        });
    };

    handleLogoRemove = (event) => {
        this.setState({
            logo: event.newState,
        }, () => {
            this.setDisabled();
        })
    }

    handleLogoReset = (event) => {
        event.preventDefault();
        const portal = this.state.portal;
        portal.logoUrl = "";
        this.setState({
            portal: portal
        }, () => {
            this.setDisabled();
        })
    };

    handleFavicon = (event) => {
        this.setState({
            favicon: event.newState,
        }, () => {
            this.setDisabled();
        });
    };

    handleFaviconRemove = (event) => {
        this.setState({
            favicon: event.newState,
        }, () => {
            this.setDisabled();
        });
    };

    handleFaviconReset = (event) => {
        this.setState({
            faviconUrl: "",
        }, () => {
            this.setDisabled();
        });
    };

    setDisabled = () => {
        let condition =
            this.state.portal.navigationBarOrientation.value !== this.defaultData.navigationBarOrientation.value ||
            this.state.entity._id !== this.defaultData.entity._id ||
            this.state.page._id !== this.defaultData.targetPageId ||
            this.state.portal.logoUrl !== this.defaultData.logoUrl ||
            this.state.portal.faviconUrl !== this.defaultData.faviconUrl ||
            this.state.portal.navigateToDefaultPage !== this.defaultData.navigateToDefaultPage ||
            this.state.logo.length > 0 ||
            this.state.favicon.length > 0

        if (this.state.logo.length > 0 && this.state.logo[0].validationErrors) {
            condition = false;
        }

        if (this.state.favicon.length > 0 && this.state.favicon[0].validationErrors) {
            condition = false;
        }

        if (condition) {
            this.setState({ disabled: false });
        } else {
            this.setState({ disabled: true });
        }
    };

    uploadAttachments = async (files) => {
        let formData = new FormData();

        files = [
            ...new Map(files.map((item) => [item["name"], item])).values(),
        ];

        for (let attachment of files) {
            if (!attachment.validationErrors) {
                let fileName =
                    attachment.name.split(
                        ".jpg" || ".png" || ".jpeg" || ".ico"
                    )[0] +
                    "_" +
                    new Date().getTime() +
                    attachment.extension;
                formData.append(`file`, attachment.getRawFile(), fileName);
            }
        }
        let path =
            this.props.organization._id +
            "/" +
            this.props.project._id +
            "/" +
            "PortalImages";
        formData.append("path", path);

        return await UploadFiletoDirectory(formData);
    };

    Save = async (e) => {
        debugger
        const { saveButton } = this;
        saveButton.current.disabled = true;
        e.preventDefault();

        let UploadLogoImages = [];
        let UploadFaviconImages = [];

        var path = "";

        if (this.state.logo.length > 0 && this.state.logo[0].name !== this.defaultData.logoUrl) {
            UploadLogoImages = await this.uploadAttachments(this.state.logo);
            path = this.props.organization._id + "/" + this.props.project._id + "/PortalImages/" + this.defaultData.logoUrl;
            DeleteFile(path, this.defaultData.logoUrl);
            this.defaultData.logoUrl = "";
        }

        if (this.defaultData.logoUrl !== this.state.portal.logoUrl) {
            path = this.props.organization._id + "/" + this.props.project._id + "/PortalImages/" + this.defaultData.logoUrl;
            DeleteFile(path, this.defaultData.logoUrl);
            this.defaultData.logoUrl = "";
        }

        if (this.state.favicon.length > 0 && this.state.favicon[0].name !== this.defaultData.faviconUrl) {
            UploadFaviconImages = await this.uploadAttachments(this.state.favicon);
            path = this.props.organization._id + "/" + this.props.project._id + "/PortalImages/" + this.defaultData.faviconUrl;
            DeleteFile(path, this.defaultData.faviconUrl);
            this.defaultData.faviconUrl = "";
        }

        if (this.defaultData.faviconUrl !== this.state.portal.faviconUrl) {
            path = this.props.organization._id + "/" + this.props.project._id + "/PortalImages/" + this.defaultData.faviconUrl;
            DeleteFile(path, this.defaultData.faviconUrl);
            this.defaultData.faviconUrl = "";
        }

        let properties = {
            navigationBarOrientation: this.state.portal.navigationBarOrientation.value,
            targetPageId: this.state.page._id,
            navigateToDefaultPage: this.state.portal.navigateToDefaultPage,
            logoUrl: UploadLogoImages.length > 0 ? UploadLogoImages.join(",") : this.defaultData.logoUrl,
            faviconUrl: UploadFaviconImages.length > 0 ? UploadFaviconImages.join(",") : this.defaultData.faviconUrl,
        }
        await updatePortal(this.props.portal._id, properties);

        const updatedportal = {
            ...this.state.portal,
            ...properties,
            entity: this.state.entity,
            page: this.state.page,
            navigationBarOrientation: this.NavigationBarOrientation.find(item => item.value === properties.navigationBarOrientation) || this.NavigationBarOrientation[0],
        }
        this.defaultData = { ...updatedportal };
        this.setState({
            portal: updatedportal,
            disabled: true,
            logo: [],
            favicon: []
        })
    };
}

export default withTranslation([
    "portal/navigation_bar_and_logo",
], {
    withRef: true
})(NavigationBarandLogo);